import { IconButton as IconButton$1 } from "@mui/material";
import { styled } from "@mui/material/styles";
import InsuranceProofIcon from "../../assets/icons/InsuranceProofIcon.js";
import "react/jsx-runtime";
const colorMap = (theme) => ({
  valid: theme.palette.success[500],
  validBackground: theme.palette.success[50],
  invalid: theme.palette.error[500],
  invalidBackground: theme.palette.error[50]
});
const StyledInsuranceProofIcon = styled(InsuranceProofIcon, {
  shouldForwardProp: (prop) => prop !== "valid"
})(({ theme, valid }) => ({
  width: "24px",
  height: "24px",
  path: {
    fill: valid ? colorMap(theme).valid : colorMap(theme).invalid
  }
}));
const IconButton = styled(IconButton$1, {
  shouldForwardProp: (prop) => prop !== "valid"
})(({ theme, valid }) => ({
  padding: 0,
  "&:hover": {
    backgroundColor: valid ? colorMap(theme).validBackground : colorMap(theme).invalidBackground
  }
}));
export {
  IconButton,
  StyledInsuranceProofIcon
};
